import { render, staticRenderFns } from "./GoodsTypeManagement.vue?vue&type=template&id=359ef76a&scoped=true"
import script from "./GoodsTypeManagement.vue?vue&type=script&lang=js"
export * from "./GoodsTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./GoodsTypeManagement.vue?vue&type=style&index=0&id=359ef76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ef76a",
  null
  
)

export default component.exports